// These values come from an Agency's parser
// and MUST mean the same across different agencies
// or else lead to great confusion
//
// We may want to consider refactoring this to a number input
// If it gets too out of hand...

export const maxRVLengthOptions = [
  {
    value: "15", // MBParks/YTParks
    label: "Up to 15'",
  },
  {
    value: "18", // BCParks/OntarioParks/NBParks/NLParks/YTParks/ElQuestro
    label: "Up to 18'",
  },
  {
    value: "20", // MBParks/NSParks
    label: "Up to 20'",
  },
  {
    value: "21", // ParksCanada/NLParks
    label: "Up to 21'",
  },
  {
    value: "22", // ElQuestro
    label: "Up to 22'",
  },
  {
    value: "24", // ParksCanada
    label: "Up to 24'",
  },
  {
    value: "25", // OntarioParks/MBParks/NBParks/SKParks
    label: "Up to 25'",
  },
  {
    value: "26", // ElQuestro
    label: "Up to 26'",
  },
  {
    value: "27", // ParksCanada/NLParks
    label: "Up to 27'",
  },
  {
    value: "30", // ParksCanada/MBParks/NSParks
    label: "Up to 30'",
  },
  {
    value: "32", // BCParks/OntarioParks/NBParks/YTParks
    label: "Up to 32'",
  },
  {
    value: "33", // BCParks/OntarioParks/NBParks/YTParks
    label: "Over 32'",
  },
  {
    value: "35", // ParksCanada/MBParks/NLParks
    label: "Up to 35'",
  },
  {
    value: "36", // ParksCanada/NLParks
    label: "Over 35'",
  },
  {
    value: "40", // AlbertaParks/MBParks/NSParks
    label: "Up to 40'",
  },
  {
    value: "41", // MBParks/NSParks
    label: "Over 40'",
  },
  {
    value: "45", // PEIParks
    label: "Up to 45'",
  },
  {
    value: "50", // AlbertaParks/FloridaParks
    label: "Up to 50'",
  },
  {
    value: "55", // FloridaParks
    label: "Up to 55'",
  },
  {
    value: "60", // AlbertaParks/FloridaParks
    label: "Up to 60'",
  },
  {
    value: "65", // FloridaParks
    label: "Up to 65'",
  },
  {
    value: "70", // FloridaParks
    label: "Up to 70'",
  },
  {
    value: "75", // FloridaParks
    label: "Up to 75'",
  },
  {
    value: "100", // FloridaParks
    label: "Up to 100'",
  },
  {
    value: "101", // FloridaParks
    label: "Over 100'",
  },
];
